export default __webpack_public_path__ + "static/media/africa.678de593.jpg";